<clr-dropdown>
    <button class="btn btn-sm btn-outline-primary" clrDropdownTrigger type="button">
        <clr-icon shape="calendar"></clr-icon>
        <span *ngIf="selectedRange === 'All'">{{ 'common.all' | translate }}</span>
        <span *ngIf="selectedRange === 'Yearly'">{{ selectedYear }}</span>
        <span *ngIf="selectedRange === 'Monthly'">{{ selectedMonth }} {{ selectedYear }}</span>
        <span
            *ngIf="
                selectedRange !== 'Monthly' &&
                selectedRange !== 'Yearly' &&
                selectedRange !== 'All'
            "
            >{{ start | date }} - {{ end | date }}</span
        >
        <clr-icon shape="caret down"></clr-icon>
    </button>
    <clr-dropdown-menu class="date-range-with-all-menu" clrPosition="bottom-right" *clrIfOpen>
        <div class="card">
            <div class="card-header">{{ 'metrics.date-settings' | translate }}</div>
            <div class="card-block">
                <div class="clr-row clr-justify-content-between">
                    <div class="clr-col-4">
                        <clr-radio-wrapper *ngFor="let preset of rangePresets">
                            <input
                                type="radio"
                                clrRadio
                                [id]="'date-range-with-all-' + preset"
                                name="date-range-with-all-preset"
                                [checked]="selectedRange === preset"
                                (change)="setRange(preset)"
                            />
                            <label [attr.for]="'date-range-with-all-' + preset">
                                {{ preset === 'All' ? ('common.all' | translate) : preset }}
                            </label>
                        </clr-radio-wrapper>
                    </div>
                    <div class="clr-col-1">&nbsp;</div>
                    <div class="clr-col-7 range-refine-column" *ngIf="showRangeRefinementSelects">
                        <select clrSelect id="date-range-year" name="year" (change)="stateChanged()" [(ngModel)]="selectedYear">
                            <option *ngFor="let item of years" [ngValue]="item.label">{{ item.label }}</option>
                        </select>

                        <select
                            clrSelect
                            id="date-range-month"
                            name="month"
                            (change)="stateChanged()"
                            [(ngModel)]="selectedMonth"
                            *ngIf="selectedRange !== 'Yearly'"
                        >
                            <option *ngFor="let item of months" [ngValue]="item.label">{{ item.label }}</option>
                        </select>

                        <select
                            clrSelect
                            id="date-range-week"
                            name="week"
                            (change)="stateChanged()"
                            [(ngModel)]="selectedMonthWeek"
                            *ngIf="selectedRange === 'Weekly' && monthWeeks.length > 0"
                        >
                            <option *ngFor="let item of monthWeeks" [ngValue]="item.label">{{ item.label }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </clr-dropdown-menu>
</clr-dropdown>
